import { useParams } from "react-router-dom";
import { Button, Container, Image, Text, Title } from "@mantine/core";
import { useForm } from "react-hook-form";
import { PasswordInput } from "react-hook-form-mantine";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetUserByForgotPasswordToken,
  useSetPassword,
} from "../../api/auth";
import { useConfirm } from "../../hooks/useConfirm";
import Logo from "../../assets/logo-02.svg";
import LoadingPage from "../common/LoadingPage";
import { web_confirmPasswordSchema } from "@congrs/schemas";
import resolver from "@congrs/resolver";

function ResetPassword() {
  const token = useParams().token;
  const navigate = useNavigate();

  const [disableForm, setDisableForm] = useState(false);

  const {
    data: userData,
    isSuccess,
    isError,
    isLoading,
  } = useGetUserByForgotPasswordToken(token);

  // Check if the token is expired or password is already set
  const notValid = userData?.status === "token expired";

  const { mutate: setPassword } = useSetPassword();

  let errorMessage;
  if (isError) {
    errorMessage = "Invalid token.";
  } else if (userData?.status === "token expired") {
    errorMessage = "Token expired.";
  }

  const confirm = useConfirm();

  useEffect(() => {
    if (isError || (isSuccess && notValid)) {
      setDisableForm(true);
    }
  }, [userData, isSuccess, isError]);

  const { control, handleSubmit } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
    },
    resolver: resolver(web_confirmPasswordSchema, { $data: true }),
  });

  const onSubmit = (data) => {
    confirm({
      title: "Save password?",
      message: "Please confirm to proceed.",
      onConfirm: () => {
        setPassword({ token, password: data.password });
        navigate("/");
      },
    });
  };

  if (isLoading) {
    return <LoadingPage />;
  }
  return (
    <Container size={420}>
      <Image src={Logo} alt="congrs logo" />
      <Title>Password reset</Title>
      <Text>Please reset your password.</Text>
      <form onSubmit={handleSubmit((data) => onSubmit(data))}>
        <PasswordInput
          label="Set Password"
          placeholder="Enter your password"
          name="password"
          control={control}
          withAsterisk
          mt="md"
          disabled={disableForm}
        />
        <PasswordInput
          label="Confirm Password"
          placeholder="Confirm your password"
          name="confirmPassword"
          control={control}
          withAsterisk
          mt="md"
          disabled={disableForm}
        />
        <Button
          type="submit"
          variant="gradient"
          fullWidth
          size="md"
          my={10}
          disabled={disableForm}
        >
          ResetPassword
        </Button>

        {disableForm && (
          <Text c="red" ta="center">
            {errorMessage}
          </Text>
        )}
      </form>
    </Container>
  );
}

export default ResetPassword;
